export const AMBITS = (t: $TSMigrationFixMe) => [
  {
    label: `${t("impuestos.modal.buyLabel")}`,
    value: 0,
  },
  {
    label: `${t("impuestos.modal.salesLabel")}`,
    value: 1,
  },
]

export const obtenerOpcionesPorGrupoImpuesto = (
  opcionesPorGrupoImpuesto: $TSMigrationFixMe,
  values: $TSMigrationFixMe
) => {
  const tipoImpuestoEmpresa = values?.tipoImpuestoEmpresa
  if (tipoImpuestoEmpresa !== null && tipoImpuestoEmpresa !== undefined) {
    return opcionesPorGrupoImpuesto[tipoImpuestoEmpresa] || {}
  }
  return {}
}
